import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17.24",
    height: "17.24",
    viewBox: "0 0 17.24 17.24",
    alt: "x"
  }, props, {
    children: /*#__PURE__*/_jsxs("g", {
      id: "Gruppe_440",
      "data-name": "Gruppe 440",
      transform: "translate(2.12 2.12)",
      children: [/*#__PURE__*/_jsx("line", {
        id: "Linie_23",
        "data-name": "Linie 23",
        x2: "12.093",
        y2: "13",
        transform: "translate(0.453)",
        fill: "none",
        stroke: props.color ? props.color : '#a1a0ae',
        strokeLinecap: "round",
        strokeWidth: "3"
      }), /*#__PURE__*/_jsx("line", {
        id: "Linie_24",
        "data-name": "Linie 24",
        x2: "12.093",
        y2: "13",
        transform: "translate(13 0.454) rotate(90)",
        fill: "none",
        stroke: props.color ? props.color : '#a1a0ae',
        strokeLinecap: "round",
        strokeWidth: "3"
      })]
    })
  }));
};
export default CloseIcon;